/* ============================================================
   Wishlist Drawer JS (component-wishlist-drawer)
   localStorage-based wishlist with drawer UI
   ============================================================ */
(function () {
  'use strict';

  const WL_KEY = 'o2pets_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WL_KEY, JSON.stringify(list));
  }

  /* Inject drawer HTML once */
  document.body.insertAdjacentHTML('beforeend', `
    <div id="WishlistDrawer" class="wishlist-drawer" aria-hidden="true" role="dialog" aria-label="Favorites">
      <div class="wishlist-drawer__overlay js-wl-close"></div>
      <div class="wishlist-drawer__panel">
        <div class="wishlist-drawer__header">
          <span class="wishlist-drawer__title">Favorites:</span>
          <button class="wishlist-drawer__close js-wl-close" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><line x1="1" y1="1" x2="15" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="15" y1="1" x2="1" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>
        <hr class="wishlist-drawer__divider">
        <div class="wishlist-drawer__items" id="WishlistItems"></div>
      </div>
    </div>
  `);

  const wlDrawer = qs('#WishlistDrawer');
  const wlItems  = qs('#WishlistItems');

  function escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function renderWishlistDrawer() {
    const list = getWishlist();
    if (!list.length) {
      wlItems.innerHTML = '<p class="wishlist-drawer__empty">Your wishlist is empty.</p>';
      return;
    }
    wlItems.innerHTML = list.map(p => `
      <div class="wishlist-item">
        <a href="${p.url}" class="wishlist-item__img-wrap">
          <img src="${p.image}" alt="${escHtml(p.title)}" class="wishlist-item__img" loading="lazy">
        </a>
        <div class="wishlist-item__info">
          <a href="${p.url}" class="wishlist-item__title">${escHtml(p.title)}</a>
          <div class="wishlist-item__price">${escHtml(p.price)}</div>
          ${p.variant ? `<div class="wishlist-item__meta">VOLUME: ${escHtml(p.variant)}</div>` : ''}
          ${p.sku    ? `<div class="wishlist-item__sku">${escHtml(p.sku)}</div>` : ''}
        </div>
        <a href="${p.url}" class="btn btn--buy wishlist-item__buy">BUY NOW</a>
        <button class="wishlist-item__remove js-wl-remove" data-product-id="${p.id}" aria-label="Remove from wishlist">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><line x1="1" y1="1" x2="11" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="11" y1="1" x2="1" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
    `).join('');
  }

  function openWishlistDrawer() {
    renderWishlistDrawer();
    wlDrawer.setAttribute('aria-hidden', 'false');
    wlDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeWishlistDrawer() {
    wlDrawer.setAttribute('aria-hidden', 'true');
    wlDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function syncWishlistButtons() {
    const list  = getWishlist();
    const ids   = list.map(p => p.id);
    const count = ids.length;
    qsa('.js-wishlist-toggle').forEach(btn => {
      const id = btn.dataset.productId;
      btn.classList.toggle('is-wishlisted', ids.includes(id));
      btn.setAttribute('aria-label', ids.includes(id) ? 'Remove from wishlist' : 'Add to wishlist');
    });
    const badge = qs('.js-wl-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    }
  }

  document.addEventListener('click', e => {
    if (e.target.closest('.js-wl-open'))  { openWishlistDrawer();  return; }
    if (e.target.closest('.js-wl-close')) { closeWishlistDrawer(); return; }
    const removeBtn = e.target.closest('.js-wl-remove');
    if (removeBtn) {
      const id   = removeBtn.dataset.productId;
      saveWishlist(getWishlist().filter(p => p.id !== id));
      renderWishlistDrawer();
      syncWishlistButtons();
      return;
    }
    const btn = e.target.closest('.js-wishlist-toggle');
    if (!btn) return;
    const id   = btn.dataset.productId;
    let   list = getWishlist();
    const idx  = list.findIndex(p => p.id === id);
    if (idx !== -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        id:      id,
        title:   btn.dataset.productTitle   || '',
        price:   btn.dataset.productPrice   || '',
        image:   btn.dataset.productImage   || '',
        url:     btn.dataset.productUrl     || '#',
        variant: btn.dataset.productVariant || '',
        sku:     btn.dataset.productSku     || '',
      });
    }
    saveWishlist(list);
    syncWishlistButtons();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeWishlistDrawer();
  });

  syncWishlistButtons();
})();
